export class DE {
    getTranslations() {
        return {
            btn_validate: 'Bestätigen',
            btn_cancel: 'Abbrechen',
            btn_close: 'Schließen',
            btn_add: 'Hinzufügen',
            btn_delete: 'Löschen',
            msg_alert: 'Warnung',
            msg_success: 'Erfolgreich',
            msg_confirm: 'Bitte bestätigen',
            msg_input: 'Eingabe',
            datahub_pickup_indicator: 'Indikatoren auswählen',
            datahub_fields: 'Felder',
            config_menu_loading: 'Menü wird geladen...',
            editable_label_edit: 'Bearbeiten',
            editable_label_validate: 'Bestätigen',
            please_wait: 'Bitte warten...',
            combobox_placeholder: 'Option auswählen',
            card_button_start: 'Anfangen',
            enter_credentials_to: 'Bitte geben Sie Ihre Zugangsdaten ein, um Zugriff zu erhalten ',
        };
    }
}
